// Sign-up. Same POST-to-Better-Auth pattern as SignIn.
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { isErr } from "@nightcrew/shared";
import { Field } from "../components/Field.js";
import { signUpWithEmail } from "../api/auth.js";
import { useSession } from "../state/session.js";
// The GENERATED lockup, kept byte-identical to docs/design/mockups/assets/nightcrew-lockup-light.svg,
// which `crew/docs-gen/identity.py` produces. Above the auth card so this surface carries the brand
// rather than a bare centered form (m2).
//
// THIS COMMENT USED TO SAY "copied verbatim - never generated" AND THE FILE WAS NEITHER. A
// verification panel found the copy here was the PRE-ADR-0027 mark: a portrait rounded rect with a
// centred `<line>` mullion, which is the lift door. The new mark is four square cells with one lit.
// So the old logo was shipping on sign-in and sign-up while every other surface in the repository
// carried the new one, and the word "verbatim" is what stopped anyone looking.
//
// CHECK 128 COULD NOT SEE IT, which is why it survived the sweep: its identity clause walks
// `docs/design/mockups/assets` and two `crew/docs-gen` mirrors, and its application clause greps
// `apps/` for css/ts/tsx/js/jsx and never for `*.svg`. That gap is closed in the same change as this
// one, so a stale mark under `apps/` now reds.
import nightcrewLockup from "../assets/nightcrew-lockup-light.svg";

export const SignUp = (): React.JSX.Element => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();
  const { refresh } = useSession();

  const handleSubmit = async (): Promise<void> => {
    setSubmitting(true);
    setError(null);
    const result = await signUpWithEmail(email, password, name);
    setSubmitting(false);
    if (isErr(result)) {
      setError("We could not create your account. Try again.");
      return;
    }
    refresh();
    void navigate("/apps", { replace: true });
  };

  return (
    <div className="wrap" style={{ maxWidth: 420, paddingBlockStart: 60 }}>
      <div className="auth-brand">
        <img src={nightcrewLockup} alt="Nightcrew" />
      </div>
      <h1 className="h2">Create your account</h1>
      <form
        onSubmit={(event) => {
          event.preventDefault();
          void handleSubmit();
        }}
        className="stack gap16 mt24"
      >
        <Field
          label="Name"
          autoComplete="name"
          value={name}
          onChange={setName}
          disabled={submitting}
        />
        <Field
          label="Email"
          type="email"
          autoComplete="email"
          value={email}
          onChange={setEmail}
          disabled={submitting}
        />
        <Field
          label="Password"
          type="password"
          autoComplete="new-password"
          value={password}
          onChange={setPassword}
          disabled={submitting}
        />
        {error != null ? (
          <p className="field-error" role="alert">
            {error}
          </p>
        ) : null}
        <button type="submit" className="btn btn-primary" disabled={submitting}>
          {submitting ? "Creating account..." : "Create account"}
        </button>
      </form>
      <p className="muted mt16">
        Already have an account?{" "}
        <Link to="/sign-in" className="link-accent">
          Sign in
        </Link>
      </p>
    </div>
  );
};
